import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as setupReducer from "containers/Setup/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Dataset from "components/Dataset/Dataset";

const getId = (props) =>
  props && props.match && props.match.params && props.match.params.datasetId ? props.match.params.datasetId : "new";

class DatasetContainer extends React.PureComponent {
  render() {
    const { id, setupId, runId, dataset } = this.props;

    if (dataset === undefined) {
      return <LoadingIndicator />;
    }

    return <Dataset {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    updateDatasetId: () => dispatch(setupReducer.updateDatasetId("new", id)),
    updateLabelFromDatasetId: (datasetId) => dispatch(setupReducer.updateLabelFromDatasetId("new", datasetId))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  return {
    id: id,
    dataset: homeReducer.getDataset(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(DatasetContainer);
